import React, { Component } from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import axios from "axios";
import { debounce } from "lodash";
import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
import moment from 'moment';
import { isNullOrUndefined } from 'util';

import ProfileCell from '../User/ProfileCell';
import VehicleCell from '../Vehicle/VehicleCell';
import MediaActionsComponent from '../../../Stakeholder/MediaActionsComponent.jsx';

import { LoadingIcon, LoadingIconRow } from '../../../Common/Loading_Icon';
import { checkCredentials } from '../../../../Helpers/checkCredentials';
import { setList } from '../../../../Actions/stakeholderActions';
import { Trans } from 'react-i18next';

class OutstandingMedia extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading_main: true,
            sort_filter: null, sort_direction: null,
            current_filters: {
                'search': "", 
                'vehicle_search': "",
                'user_search': "",
                'oem': {}, 
                'model': {}, 
                'profile': {},
                'booking': {'min': 0, 'max': 100},
            },
            previous_filters: {
                'search': "", 
                'vehicle_search': "",
                'user_search': "",
                'oem': {}, 
                'model': {}, 
                'profile': {},
                'booking': {'min': 0, 'max': 100},
            },
            default_filters: {
                'search': "", 
                'vehicle_search': "",
                'user_search': "",
                'oem': {}, 
                'model': {}, 
                'profile': {},
                'booking': {'min': 0, 'max': 100},
            },
            filter_dropdowns: {'vehicle': false, 'booking': false, 'profile': false},
            total_media: 0,
            outstanding_bookings_data: {'filters': {'profiles': [], 'oem': [], 'model': []}, 'outstanding_bookings': []},
            toggle_more: {'users': false, 'oem': false},
            max_media_render: 10,
            initial_max_media_render: 10,
            has_oem_access: false,
            searching: false,
            searching_vehicles: false,
            searching_users: false,
            set_max_media: false,
            mobile_filters: false,
            mobile_quick: false,
            set_outstanding: false
        };
        this.watchScroll = this.watchScroll.bind(this);
        this.checkScreenHeight = this.checkScreenHeight.bind(this);
        
        this.applyFilters = this.applyFilters.bind(this);
        this.resetFilters = this.resetFilters.bind(this);
        
        this.checkScreenHeight = this.checkScreenHeight.bind(this);
        this.toggleMobile = this.toggleMobile.bind(this);
        
        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.handleChange = debounce(this.handleChange, 500);
        this.clearSearch = this.clearSearch.bind(this);

        this.updateButton = this.updateButton.bind(this);
        this.updateCheckBox = this.updateCheckBox.bind(this);
        this.updateSorting = this.updateSorting.bind(this);

        this.addSortClasses = this.addSortClasses.bind(this);
        this.changedFilters = this.changedFilters.bind(this);
        this.categoryCollapsable = this.categoryCollapsable.bind(this);
    }

    componentDidMount() {
        var self = this;

        if (this.props.loading_main !== this.state.loading_main && ! isNullOrUndefined(this.props.outstanding_bookings)) {
            var filters = self.state.current_filters;
            var dropdowns = self.state.filter_dropdowns;

            var data = JSON.parse(JSON.stringify(this.props.outstanding_bookings));

            var oem_keys = Object.keys(data.filters.oem)
            var oem = []
            for (var i = 0; i < oem_keys.length; i++) {
                filters['oem'][oem_keys[i]] = false; 
                dropdowns[oem_keys[i]] = false;
                oem.push(
                    {'OEM_ID': oem_keys[i], 'Company': data.filters.oem[oem_keys[i]]}
                )
            }

            var model_keys = Object.keys(data.filters.model);
            var model = []
            for (var i = 0; i < model_keys.length; i++) {
                filters['model'][data.filters.model[model_keys[i]]] = false; 
                model.push(
                    {'Model': data.filters.model[model_keys[i]]}
                )
            }

            var profile_keys = Object.keys(data.filters.profiles);
            var profile = []
            for (var i = 0; i < profile_keys.length; i++) {
                filters['profile'][profile_keys[i]] = false; 
                profile.push(
                    {'ID': profile_keys[i], 'Full_Name': data.filters.profiles[profile_keys[i]]}
                )
            }

            let profile2 = profile.sort(function(a, b) {
                var nameA = a.Full_Name.toUpperCase(); // ignore upper and lowercase
                var nameB = b.Full_Name.toUpperCase(); // ignore upper and lowercase
                if (nameA < nameB) {
                  return -1;
                }
                if (nameA > nameB) {
                  return 1;
                }
              
                // names must be equal
                return 0;
              });
            data.filters['oem'] = oem;
            data.filters['model'] = model;
            data.filters['profiles'] = profile2;

            this.setState({
                outstanding_bookings_data: data,
                loading_main: this.props.loading_main,
                total_media: this.props.outstanding_bookings.outstanding_bookings.length,
                current_filters: JSON.parse(JSON.stringify(filters)),
                previous_filters: JSON.parse(JSON.stringify(filters)),
                default_filters: JSON.parse(JSON.stringify(filters)),
            });

            
        }
    }

    componentWillReceiveProps(nextProps) {
        var self = this;

        if (!this.state.set_outstanding && nextProps.loading_main !== this.state.loading_main && ! isNullOrUndefined(nextProps.outstanding_bookings)) {
            var filters = self.state.current_filters;
            var dropdowns = self.state.filter_dropdowns;

            var data = JSON.parse(JSON.stringify(nextProps.outstanding_bookings));

            var oem_keys = Object.keys(data.filters.oem)
            var oem = []
            for (var i = 0; i < oem_keys.length; i++) {
                filters['oem'][oem_keys[i]] = false; 
                dropdowns[oem_keys[i]] = false;
                oem.push(
                    {'OEM_ID': oem_keys[i], 'Company': data.filters.oem[oem_keys[i]]}
                )
            }

            var model_keys = Object.keys(data.filters.model);
            var model = []
            for (var i = 0; i < model_keys.length; i++) {
                filters['model'][data.filters.model[model_keys[i]]] = false; 
                model.push(
                    {'Model': data.filters.model[model_keys[i]]}
                )
            }

            var profile_keys = Object.keys(data.filters.profiles);
            var profile = []
            for (var i = 0; i < profile_keys.length; i++) {
                filters['profile'][profile_keys[i]] = false; 
                profile.push(
                    {'ID': profile_keys[i], 'Full_Name': data.filters.profiles[profile_keys[i]]}
                )
            }
            
            let profile2 = profile.sort(function(a, b) {
                var nameA = a.Full_Name.toUpperCase(); // ignore upper and lowercase
                var nameB = b.Full_Name.toUpperCase(); // ignore upper and lowercase
                if (nameA < nameB) {
                  return -1;
                }
                if (nameA > nameB) {
                  return 1;
                }
              
                // names must be equal
                return 0;
              });
            data.filters['oem'] = oem;
            data.filters['model'] = model;
            data.filters['profiles'] = profile2;

            this.setState({
                outstanding_bookings_data: data,
                loading_main: nextProps.loading_main,
                total_media: nextProps.outstanding_bookings.outstanding_bookings.length,
                current_filters: JSON.parse(JSON.stringify(filters)),
                previous_filters: JSON.parse(JSON.stringify(filters)),
                default_filters: JSON.parse(JSON.stringify(filters)),
                set_outstanding: true
            });

        }
    }

    componentDidUpdate() {
        this.checkScreenHeight()
    }

    checkScreenHeight() {
        if (! this.state.set_max_media) {
            var num_to_add = Math.round((document.documentElement.clientHeight - (this.state.max_media_render * 52)) / 52)

            this.setState({
                max_media_render: this.state.max_media_render + num_to_add,
                initial_max_media_render: this.state.max_media_render + num_to_add,
                set_max_media: true
            })
        }
    }

    watchScroll(e) {
        if (! this.state.loading_media && this.props.stakeholder.outstanding_media_list.length > this.state.max_media_render) {
            var scroll_percentage = (e.target.scrollTop / (e.target.scrollHeight - e.target.clientHeight)) * 100
            if (scroll_percentage > 60) {
                this.setState({
                    max_media_render: this.state.max_media_render + 10
                })
            }
        }
    }

    toggleMobile(name) {
        this.setState({
            [name]: !this.state[name]
        })
    }

    handleChange(id) {
        var search = document.getElementById(id).value;
        var filters = this.state.current_filters;
        filters['search'] = search;

        this.setState({
            searching: true,
            filters: filters
        })

        this.applyFilters()
    }

    clearSearch() {
        var filters = this.state.current_filters;
        filters['search'] = "";
        document.getElementById('searchbar').value = "";


        this.setState({
            filters: filters
        })

        this.applyFilters()
    }

    applyFilters(sort_filter = this.state.sort_filter, sort_direction = this.state.sort_direction) {
        var self = this;
        this.setState({
            loading_main: true,
            mobile_filters: false
        })
        var data = {
                    search_term: this.state.current_filters.search,
                    sort_filter: sort_filter,
                    sort_direction: sort_direction,
                    booking_min: this.state.current_filters.booking.min,
                    booking_max: this.state.current_filters.booking.max,
                }


        var filters = this.state.current_filters;
        var categories = Object.keys(filters);
        for (var i = 0; i < categories.length; i++) {
            data[categories[i]] = "";
            if (typeof filters[categories[i]] === "object" && (categories[i] !== "search" && categories[i] !== "booking")) {
                var items = Object.keys(filters[categories[i]]);
                for (var k = 0; k < items.length; k++) {
                    if (filters[categories[i]][items[k]] === true) {
                        if (data[categories[i]] === "") {
                            data[categories[i]] = items[k]
                        } else {
                            data[categories[i]] = data[categories[i]] + "#" + items[k]
                        }
                    }
                }
            }
        }
        
        axios({
            method: 'post',
            url: '/ajax/medialist/outstanding',
            data: data
        })
        .then(function(response) {
            checkCredentials(response)
            self.props.dispatch(setList("SET_OUTSTANDING_MEDIA_LIST", response?.data.outstanding_bookings))

            self.setState({                
                loading_main: false,
                max_media_render: self.state.initial_max_media_render,
                searching: false,
                previous_filters: JSON.parse(JSON.stringify(self.state.current_filters))
            })
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    updateSorting(name) {
        var sort_direction = this.state.sort_direction;
        var sort_filter = this.state.sort_filter;

        if (sort_filter !== name) {
            sort_filter = name;
            sort_direction = "desc";
        } else {
            if (sort_direction === "desc") {
                sort_direction = "asc"
            } else if (sort_direction === "asc") {
                sort_direction = null
                sort_filter = null
            } else {
                sort_filter = name;
                sort_direction = "asc"
            }
        }

        this.setState({
            sort_direction: sort_direction,
            sort_filter: sort_filter
        })

        this.applyFilters(sort_filter, sort_direction)
    }

    toggleDropdown(type) {
        var filter_dropdowns = this.state.filter_dropdowns
        filter_dropdowns[type] = !filter_dropdowns[type]
        this.setState({
            filter_dropdowns: filter_dropdowns
        })
    }

    updateButton(button) {
        var filters = this.state.current_filters
        filters['activity'][button] = !this.state.current_filters['activity'][button]

        this.setState({
            current_filters: JSON.parse(JSON.stringify(filters)),
            previous_filters: JSON.parse(JSON.stringify(filters))
        })

        this.applyFilters();
    }

    updateCheckBox(category, check) {
        var filters = this.state.current_filters;
        filters[category][check] = !this.state.current_filters[category][check]
        this.setState({
            filters: filters
        })
    }

    updateRange(e, category) {
        var filters = this.state.current_filters;
        filters[category]['min'] = e[0]
        filters[category]['max'] = e[1]

        this.setState({
            filters: filters
        })
    }

    /*
    * Compares previous filters with recently checked ones, returns true if the filters have been changed and can be updated
    */
   changedFilters(compare_dictionary) {
        if (JSON.stringify(compare_dictionary) !== JSON.stringify(this.state.current_filters)) {
            return true;
        }

        return false;
    }

    addSortClasses(name) {
        if (this.state.sort_filter === name) {
            if (this.state.sort_direction === "asc") {
                return " fa-sort-up primary"
            } else if (this.state.sort_direction === "desc"){
                return " fa-sort-down primary"
            }
        } else {
            return " fa-sort"
        }
    }
    resetFilters() {
        this.setState({
            current_filters: JSON.parse(JSON.stringify(this.state.default_filters)),
            previous_filters: JSON.parse(JSON.stringify(this.state.default_filters)),
            loading_main: true,
            mobile_filters: false
        })
        
        var self = this;

        axios.post('/ajax/medialist/outstanding')
        .then(function(response) {
            checkCredentials(response)
            self.props.dispatch(setList("SET_OUTSTANDING_MEDIA_LIST", response?.data.outstanding_bookings))
            self.setState({
                loading_main: false
            })
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    /*
    * Checks if a category is collapsable 
    */
    categoryCollapsable(category) {
        var filters = this.state.current_filters;
        if (category in filters) {
            var items = Object.keys(filters[category]);
            for (var k = 0; k < items.length; k++) {
                if (filters[category][items[k]]) {
                    return false;
                }
            }
        }
        return true;
    }

    render() {
        return (
            <div className = "list-container">
                <div className = "list-wrapper">
                <div className = {"filterbar" + (this.state.mobile_filters ? " is-shown" : "")}> {/*add class 'is-shown' to unhide on mobile */}
                        <div className = "filtertitle-wrapper">
                            <div className = "filtertitle">
                            {this.state.total_media > 0 ? <h2>{this.props.stakeholder.outstanding_media_list.length}/{this.state.total_media} <Trans>Media to Add</Trans></h2> : <h2>0 <Trans>Media to Add</Trans></h2>}
                            <a className = "close-icon" onClick={() => (this.toggleMobile('mobile_filters'))}>
                                <img src = "images/png-icons/close-grey.png"/>
                            </a>
                            </div>
                        </div>
                        <div className = "filtersection">
                            <div className = "filtersection-wrapper">
                                {/* If Outstanding */}
                                <ul className = "outstanding-tab">
                                    <li className={"filter-expandable" + (this.state.filter_dropdowns.booking ? " is-expanded" : "")}>
                                        <span className = "filter-name"><Trans>Booking Date</Trans></span>
                                        {
                                            this.state.current_filters.booking.min === 0 && this.state.current_filters.booking.max === 100 ?
                                                <div className={"expand-btn" + (this.state.filter_dropdowns.booking ? " is-expanded": "")} onClick={() => this.toggleDropdown('booking')}></div>
                                            :
                                                <div className="expand-btn is-expanded disabled"></div>
                                        }
                                        <div className = "clearfix"></div>
                                        <ul className = "filter-ul filter-slider">
                                            <li>
                                            <p>{this.state.current_filters.booking.min} - {this.state.current_filters.booking.max}{this.state.current_filters.booking.max === 100 ? <span>+</span> : null} <Trans>days</Trans></p>
                                                <Range allowCross={false} min={0} max={100} defaultValue={[0, 100]} value={[this.state.current_filters.booking.min, this.state.current_filters.booking.max]} onChange={(e) => {this.updateRange(e, "booking")}} />
                                                <div className = "clearfix"></div>
                                            </li>
                                        </ul>
                                    </li>
                                    <li className={"filter-expandable" + (this.state.filter_dropdowns.profile ? " is-expanded" : "")}>
                                        <span className = "filter-name"><Trans>User</Trans></span>
                                        {
                                            this.categoryCollapsable('profile') ?
                                                <div className={"expand-btn" + (this.state.filter_dropdowns.profile ? " is-expanded": "")} onClick={() => this.toggleDropdown('profile')}></div>
                                            :
                                                <div className="expand-btn is-expanded disabled"></div>
                                        }
                                        <div className = "clearfix"></div>
                                        <ul className = "filter-ul">
                                            {
                                                this.state.outstanding_bookings_data.filters.profiles.map((profile) => {
                                                    return(
                                                        <li style = {{flex: 1, display: 'flex', flexDirection: 'row'}} key={profile.ID}>
                                                            <label className = "has-icon float-left">
                                                                <input type = "checkbox" checked={this.state.current_filters.profile[profile.ID]} onClick={() => this.updateCheckBox('profile', profile.ID)}/>
                                                                <span className = "checkmark"></span>
                                                                {profile.Full_Name}
                                                            </label>
                                                        </li>
                                                    )
                                                })
                                            }
                                            <div className = "clearfix"></div>
                                        </ul>
                                        {/*<p className = 'link showmore'>Show More</p>*/}
                                    </li> 
                                    <li className={"filter-expandable" + (this.state.filter_dropdowns.vehicle ? " is-expanded" : "")}>
                                                <span className = "filter-name"><Trans>Vehicle</Trans></span>
                                                {
                                                    this.categoryCollapsable('vehicle') ?
                                                        <div className={"expand-btn" + (this.state.filter_dropdowns.vehicle ? " is-expanded": "")} onClick={() => this.toggleDropdown('vehicle')}></div>
                                                    :
                                                        <div className="expand-btn is-expanded disabled"></div>
                                                }
                                                <div className = "clearfix"></div>
                                                <ul className = "filter-ul">
                                                    {
                                                        this.state.outstanding_bookings_data.filters.oem.length > 0 ? 
                                                            this.state.outstanding_bookings_data.filters.oem.length > 1 ? 
                                                                this.state.outstanding_bookings_data.filters.oem.map((oem) => {
                                                                    return(
                                                                        <li style={{width: 'auto'}}>
                                                                            <label className = "has-icon float-left">
                                                                                <input type = "checkbox" checked={this.state.current_filters['oem'][oem.OEM_ID]} onClick={() => this.updateCheckBox('oem', oem.OEM_ID)}/>
                                                                                <span className = "checkmark"></span>
                                                                                {oem.Company}
                                                                            </label>
                                                                            {
                                                                                this.categoryCollapsable(oem.OEM_ID) ?
                                                                                    <div className={"expand-btn float-right" + (this.state.filter_dropdowns[oem.OEM_ID] ? " is-expanded": "")} onClick={() => this.toggleDropdown(oem.OEM_ID)}></div>
                                                                                :
                                                                                    <div className="expand-btn float-right is-expanded disabled"></div>
                                                                            }
                                                                            <div className = "clearfix"></div>
                                                                            {
                                                                                this.state.filter_dropdowns[oem.OEM_ID] ?
                                                                                    <ul className = "filter-ul mb-8">
                                                                                    {
                                                                                        this.state.outstanding_bookings_data.filters.model.map((model) => {
                                                                                            return(
                                                                                                model.OEM_ID === oem.OEM_ID ?
                                                                                                <li>
                                                                                                    <label className = "has-icon">
                                                                                                        <input type = "checkbox" checked={this.state.current_filters['model'][model.Model]} onClick={() => this.updateCheckBox('model', model.Model)}/>
                                                                                                        <span className = "checkmark"></span>
                                                                                                        {model.Model}
                                                                                                    </label>
                                                                                                </li>
                                                                                            :
                                                                                                null
                                                                                            )
                                                                                        })   
                                                                                    }
                                                                                    </ul>
                                                                                :
                                                                                    null
                                                                        }
                                                                    </li>
                                                                )
                                                            })
                                                        :
                                                            <li style = {{width:'auto'}}>
                                                                <label className = "has-icon float-left">
                                                                    <input type = "checkbox" checked={true}/>
                                                                    <span className = "checkmark"></span>
                                                                    {this.state.outstanding_bookings_data.filters.oem[0].Company}
                                                                </label>
                                                                <div className = "expand-btn float-right is-expanded disabled"></div>
                                                                <div className = "clearfix"></div>
                                                                <ul className = "filter-ul mb-8">
                                                                    {
                                                                        this.state.outstanding_bookings_data.filters.model.map((model) => {
                                                                            return(
                                                                                <li>
                                                                                    <label className = "has-icon">
                                                                                        <input type = "checkbox" checked={this.state.current_filters['model'][model.Model]} onClick={() => this.updateCheckBox('model', model.Model)}/>
                                                                                        <span className = "checkmark"></span>
                                                                                        {model.Model}
                                                                                    </label>
                                                                                </li>
                                                                            )
                                                                        })
                                                                    }
                                                                </ul>
                                                            </li>
                                                    :
                                                        null
                                                    }
                                                </ul>
                                                {/*<p className = 'link showmore'>Show More</p>*/}
                                            </li> 
                                </ul>
                            </div>
                        </div>
                        <div className = "action-bottom">
                            <div className = "right">
                            <a className = {"button secondary mr-8 px-32 no-margin" + (this.changedFilters(this.state.default_filters) ? "" : " disabled")} onClick={() => this.resetFilters()}><Trans>Reset</Trans></a>
                                        <a className = {"button primary px-32 no-margin" + (this.changedFilters(this.state.previous_filters) ? "" : " disabled")} onClick={() => this.applyFilters()}><Trans>Apply Filters</Trans></a>
                            </div>
                        </div>
                    </div> {/*End Filter Bar*/}
                    <div className = "mainsection">
                        <div className = "searchbar-section">
                            <div className = "left">
                                <div className = "searchbar-wrapper">
                                <a className = "float-left button border white px-32 icon-btn filterbar-btn-mobile" onClick={() => {this.toggleMobile('mobile_filters')}}><img src = "images/png-icons/filter-grey.png"/> </a> 
                                    <div className = "search-field-container">
                                        <input className="search-input-field no-margin" type="text" placeholder = "Search Media" id="searchbar" onChange={(e) => {this.handleChange('searchbar')}} />
                                            {/*Show when searching*/}
                                            {
                                                this.state.searching ?
                                                    <div className="loading-wrapper">
                                                        <div className="lds-ring bkg-border-primary"><div></div><div></div><div></div><div></div></div>
                                                    </div>
                                                :
                                                    null
                                            }

                                            {/*Show when input field has text*/}
                                            {
                                                this.state.current_filters.search.length && !this.state.searching > 0 ?
                                                    <a className = "close-icon" onClick={this.clearSearch}>
                                                        <img src = "images/png-icons/close-grey.png"/>
                                                    </a> 
                                                :
                                                    null
                                            }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className = "table-section" onScroll={this.watchScroll}>
                            {
                                this.state.loading_main ?
                                    <LoadingIcon />
                                :
                                    this.state.total_media > 0 ?
                                        this.props.stakeholder.outstanding_media_list.length > 0 ?
                                            <div className = "table-wrapper" onScroll={this.watchScroll}>
                                                <table className = "outstanding-tab">
                                                    <thead>
                                                        <tr>
                                                            <th className = {this.state.sort_filter === "booking" ? "is-sorted" : null} onClick={() => {this.updateSorting("booking")}}>Booking Dates <i className = {"sort-icon fas black-lightest" + (this.addSortClasses("booking"))}></i></th>
                                                            <th className = {this.state.sort_filter === "user" ? "is-sorted" : null} onClick={() => {this.updateSorting("user")}}>User<i className = {"sort-icon fas black-lightest" + (this.addSortClasses("user"))}></i></th>
                                                            <th className = {this.state.sort_filter === "vehicle" ? "is-sorted" : null} onClick={() => {this.updateSorting("vehicle")}}>Vehicle<i className = {"sort-icon fas black-lightest" + (this.addSortClasses("vehicle"))}></i></th>
                                                            <th className = "not-sortable"><Trans>Actions</Trans></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            this.props.stakeholder.outstanding_media_list.slice(0, this.state.max_media_render).map((item) => {
                                                                return (
                                                                    <tr key={item.BOOK_ID}>
                                                                        <td>
                                                                            { moment(item.Start_Date).format("MMM DD, YY") } – {  moment(item.End_Date).format("MMM DD, YY") }
                                                                        </td>
                                                                        <td>
                                                                            <ProfileCell history={this.props.history} match={this.props.match} location={this.props.location} profile={item.profile} showImage showTooltip/>
                                                                        </td>
                                                                        <td>
                                                                            <VehicleCell history={this.props.history} match={this.props.match} location={this.props.location} vehicle={item.vehicle} showImage showTooltip/>
                                                                        </td>
                                                                        <td className = "action-cell">
                                                                            {
                                                                                item.has_authorizing ?
                                                                                    <MediaActionsComponent match={this.props.match} history={this.props.history} id={item.BOOK_ID} media={item} add_button={true} edit_button={false} dismiss_button={true} />
                                                                                :
                                                                                    <span />
                                                                            }
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                        <tr className="row-nohover" style={{height: '100%'}}>
                                                            <td className="row-nohover" colSpan={4}></td>
                                                        </tr>
                                                        {
                                                            ! this.state.loading_main && this.props.stakeholder.outstanding_media_list.length > this.state.max_media_render ?
                                                                LoadingIconRow(4)
                                                            :
                                                                null
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        :
                                            <div className = "emptystate-wrapper is-shown">
                                                <h2><Trans>No Media Found</Trans></h2>
                                                <img src = "images/emptystate-icons/Media_Inactive.svg" style = {{height:'104px'}}/>
                                                <p><Trans>Try adjusting your search or filter options</Trans>.</p>
                                            </div>
                                    :
                                        <div className = "emptystate-wrapper is-shown">
                                            <h2><Trans>No Media</Trans></h2>
                                            <img src = "images/emptystate-icons/Media_Inactive.svg" style = {{height:'104px'}}/>
                                            <p className = "mb-16"><Trans>No Outstanding Media</Trans></p>
                                        </div>              
                            }
                        </div>{/*End Table Section*/}
                    </div>
                </div> {/*End New List View*/}
            </div>
        
        );
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    stakeholder: store.stakeholder
})

export default connect(mapStateToProps)(OutstandingMedia)